//
// class for number data type
//
// @extends [DataFormatterType]
//
import { DataFormatterType } from '../DataFormatterType';
import { DataFormatterOptions } from '../DataFormatterType';
import { DataTools } from '../../utils/DataTools';
import { Localizer } from '../../localize/localizer';

// See Numeral.js - http://numeraljs.com/
import numeral from 'numeral';

/**
 * Data formatter for general numeric types
 * @ignore
 */
export class DataFormatNumber extends DataFormatterType {
    constructor(...args: any[]) {
        super();
    }

    // Text alignment default
    getAlign(): string {
        return 'right';
    }

    getName(): string {
        return 'number';
    }

    /* Return option text to the right of the display value */
    getUnitText(options?: DataFormatterOptions): string {
		if (options && options.displayunit && options.displayunit.length > 0)
			return options.displayunit;
        return '';
    }

    /* Default options for the number formatter */
    initializeOptions(): DataFormatterOptions {
        return {
            format: Localizer.Instance().useCommaInNumber() ? '#,###.[##]' : '####.[##]',
        };
    }

    /*
    Format data as a number.
    Options can have format='<numeral js template>'
    */
    format(data: any, options?: DataFormatterOptions, refObj?: any): string {
        const myOptions: DataFormatterOptions = this.getOptions(options);

        if (data == null) {
            return '';
        }

        if (data === null || (typeof data === 'string' && data.length === 0)) {
            return '';
        }

        const num = DataTools.getNumber(data);
        if (num === null) return '';
        if (isNaN(num)) {
            return `[${num}]`;
        }

        try {
            return numeral(num).format(myOptions.format);
        } catch (e) {
            console.log(`Exception formatting number [${num}] using [${options}]`);
            return `[${num}]`;
        }
    }

    /*
    Format the data for export.  As this is a basic type, we want CSV files
    to have the raw number value.
    */
    formatExport(data: any, options?: DataFormatterOptions, refObj?: any): any {
        return DataTools.getNumber(data);
    }

    //
    // funtion to unformat the currently formatted data
    //
    // @param [Object] data data to be unformatted
    // @return [Object] data unformatted data
    //
    unformat(data: any): any {
        if (data === undefined) return undefined;
        if (data === null) return undefined;
        if (data === '') return undefined;
        return DataTools.getNumber(data);
    }
}

export default DataFormatNumber;
